import dayjs from "dayjs";
import React from "react";
import QRCode from "react-qr-code";
import Button from "../../../../components/ui/Button/Button";

export default function QRDetail({ onEditForm, productCodeQR, product }) {
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="w-full">
          <div className="flex border-x border-t border-primary-grey ">
            <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
              상품번호
            </div>
            <div className="bg-white p-3 w-full">
              {product?.productGroup?.productNo || "-"}
            </div>
          </div>
          <div className="flex border-x border-t border-primary-grey ">
            <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
              카테고리
            </div>
            <div className="bg-white p-3 w-full">
              {product?.productGroup?.productGroupCategory?.name}
            </div>
          </div>
          <div className="flex border-x border-t border-primary-grey ">
            <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
              상품명
            </div>
            <div className="bg-white p-3 w-full">{product?.name}</div>
          </div>{" "}
          <div className="flex border-x border-t border-b border-primary-grey ">
            <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
              REF(상품코드)
            </div>
            <div className="bg-white p-3 w-full">{product?.ref}</div>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <h2 className="text-[14px] font-bold mb-4">QR 정보</h2>
        <div>
          <div className="flex border-x border-t border-primary-grey ">
            <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
              <span>QR코드 입력정보</span>
            </div>
            <div className="w-full">
              <div className="flex">
                <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                  LOT
                </div>

                <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                  {productCodeQR?.lotNo}
                </div>
              </div>

              <div className="flex">
                <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                  제조일자
                </div>

                <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                  {dayjs(productCodeQR?.manufacDate).format("YYYY-MM-DD")}
                </div>
              </div>
              <div className="flex">
                <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                  유효일자
                </div>

                <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                  {dayjs(productCodeQR?.expireDate).format("YYYY-MM-DD")}
                </div>
              </div>
            </div>
          </div>

          <div className="flex border-x border-t border-primary-grey ">
            <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
              <span>QR번호 등록정보</span>
            </div>
            <div className="w-full">
              <div className="flex">
                <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                  QR번호
                </div>

                <div className="flex gap-0 items-center bg-white px-4 py-2 w-full border-b border-primary-grey">
                  {productCodeQR?.qrNo}
                </div>
              </div>

              <div className="flex">
                <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                  QR이미지
                </div>

                <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                  <div className="rounded-md border border-primary-grey w-24 h-24 flex items-center justify-center">
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                        padding: "6px",
                      }}
                      value={productCodeQR?.qrNo}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="my-4" />
      <div className="flex justify-end">
        <Button
          borderColor="border-[#bbbbbb] border"
          type="button"
          text="재고 상세내역 이동"
        />
        <Button
          borderColor="border-[#bbbbbb] border"
          type="button"
          text="정보 변경"
          onClick={onEditForm}
        />
      </div>
    </>
  );
}
